import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location)
    // .catch(err => err)
}


let RouteList = [{
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: true
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },

    //个人资料
    Personal.index,
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    {
        path: '/price_item',
        name: 'priceItem',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/price_item.vue'], resolve),
    },
    {
        path: '/goodsPrice',
        name: 'goodsPrice',
        meta: {
            title: '价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/goodsPrice.vue'], resolve),
    },
    {
        path: '/user_list',
        name: 'userList',
        meta: {
            title: '用户列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/user_list.vue'], resolve),
    },
    {
        path: '/goods_order',
        name: 'goodsOrder',
        meta: {
            title: '影票订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/goods_order.vue'], resolve),
    },
    {
        path: '/cards_order',
        name: 'cardsOrder',
        meta: {
            title: '品城卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/site/cards_order.vue'], resolve),
    },
    // {
    //     path: '/settle_order',
    //     name: 'settleOrder',
    //     meta: {
    //         title: '结算订单',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/site/settle_order.vue'], resolve),
    // },
    {
        path: '/mahua_orders',
        name: 'mahuaOrders',
        meta: {
            title: '点餐订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/mahua_orders.vue'], resolve),
    },
    {
        path: '/local_order',
        name: 'localOrder',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/local_order.vue'], resolve),
    },
    {
        path: '/oil_orders',
        name: 'oilOrders',
        meta: {
            title: '油卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/oil_orders.vue'], resolve),
    },
    {
        path: '/tel_orders',
        name: 'telOrders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/goods_orders',
        name: 'goodsorders',
        meta: {
            title: '电商订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/goods_orders.vue'], resolve),
    },

    {
        path: '/user_withdrawal',
        name: 'userWithdrawal',
        meta: {
            title: '用户提现',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/user_withdrawal.vue'], resolve),
    },
    {
        path: '/apl_records',
        name: 'aplRecords',
        meta: {
            title: '线下影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/apl_records.vue'], resolve),
    },
    {
        path: '/movie_card',
        name: 'movieCard',
        meta: {
            title: '我的影城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/mine_cards.vue'], resolve),
    },
    {
        path: '/mine_account',
        name: 'mineAccount',
        meta: {
            title: '我的账户',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/account.vue'], resolve),
    },
    {
        path: '/mine_data',
        name: 'mineData',
        meta: {
            title: '站点资料',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/mineData.vue'], resolve),
    },
    {
        path: '/open_card',
        name: 'openCard',
        meta: {
            title: '线上品城卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/open_card.vue'], resolve),
    },
    {
        path: '/kefu',
        name: 'kefu',
        meta: {
            title: '客服中心',
            keepAlive: false
        },
        component: resolve => require(['@/views/cards/kefu.vue'], resolve),
    },
    {
        path: '/couponFf',
        name: 'couponFf',
        meta: {
            title: '优惠券投放',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_ff.vue'], resolve),
    },
    {
        path: '/couponRecords',
        name: 'couponRecords',
        meta: {
            title: '券码记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/coupon/coupon_records.vue'], resolve),
    },
    {
        path: '/act_h5_coupon',
        name: 'act_h5_coupon',
        meta: {
            title: 'H5活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_h5_coupon.vue'], resolve),
    },
    {
        path: '/act_miniapp_coupon',
        name: 'act_miniapp_coupon',
        meta: {
            title: '小程序活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/act/act_miniapp_coupon.vue'], resolve),
    },
    {
        path: '/push',
        name: 'push',
        meta: {
            title: '公众号推文',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/push.vue'], resolve),
    },
    {
        path: '/weibo',
        name: 'weibo',
        meta: {
            title: '微博推文',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/weibo.vue'], resolve),
    },
    {
        path: '/patch',
        name: 'patch',
        meta: {
            title: '贴片管理',
            keepAlive: false,
        },
        component: resolve => require(['@/views/push/patch.vue'], resolve),
    },
    {
        path: '/recharge',
        name: 'recharge',
        meta: {
            title: '充值',
            keepAlive: false,
        },
        component: resolve => require(['@/views/recharge/recharge.vue'], resolve),
    },
    {
        path: '/tags',
        name: 'tags',
        meta: {
            title: '标签统计',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/tags.vue'], resolve),
    },
    {
        path: '/subAccount',
        name: 'subAccount',
        meta: {
            title: '子账号管理',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/subAccount.vue'], resolve),
    },
    {
        path: '/bindOfficial',
        name: 'bindOfficial',
        meta: {
            title: '绑定公众号',
            keepAlive: false,
        },
        component: resolve => require(['@/views/account/bindOfficial.vue'], resolve),
    },
    {
        path: '/business_list',
        name: 'business_list',
        meta: {
            title: '商家管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/business_list.vue'], resolve),
    },
    {
        path: '/business_edit',
        name: 'business_edit',
        meta: {
            title: '商家信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/business_edit.vue'], resolve),
    },
    {
        path: '/inSettlement_list',
        name: 'inSettlement_list',
        meta: {
            title: '结算中',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/inSettlement_list.vue'], resolve),
    },
    {
        path: '/store_list',
        name: 'store_list',
        meta: {
            title: '门店管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/store_list.vue'], resolve),
    },
    {
        path: '/store_edit',
        name: 'store_edit',
        meta: {
            title: '门店信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/store_edit.vue'], resolve),
    },
    {
        path: '/member_list',
        name: 'member_list',
        meta: {
            title: '成员管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/member_list.vue'], resolve),
    },
    {
        path: '/goods_list',
        name: 'goods_list',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_list.vue'], resolve),
    },
    {
        path: '/goods_edit',
        name: 'goods_edit',
        meta: {
            title: '商品信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/goods_edit.vue'], resolve),
    },
    {
        path: '/localOrder',
        name: 'localOrder',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_order.vue'], resolve),
    },
    {
        path: '/price_template',
        name: 'price_template',
        meta: {
            title: '自主出票价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/price_template.vue'], resolve),
    },
    {
        path: '/userShare',
        name: 'userShare',
        meta: {
            title: '用户分佣',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/userShare.vue'], resolve),
    },
    {
        path: '/payConfig',
        name: 'payConfig',
        meta: {
            title: '收款配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/account/payConfig.vue'], resolve),
    },
    
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},

{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})